import { useInView } from "react-intersection-observer";
import { plausible } from '../../common/tracking';

type PagePositionReporterProps = {
    trackingKey: string,
    auditId?: number | string
}

export default function PagePositionReporter({trackingKey, auditId}: PagePositionReporterProps) {
    
    const { ref } = useInView({
        triggerOnce: true,
        rootMargin: "-200px 0px",
        onChange: (inView) => {
            if (inView) {
                console.log("PagePositionReporter firing:", "trackingKey:",trackingKey, "auditId:",auditId);
                
                // Fire a tracking event to your tracking service of choice.
                plausible(trackingKey, { props: { id: auditId ? auditId : undefined } })
            }
        },
    });

    return (
        <div ref={ref} className='page-position-reporter' />
    )
}